class SergeSignupBlock extends HTMLElement {
  
    constructor() {
      super();    
    }
    
    connectedCallback() {
      this.initialize(this);
    }

    initialize(self){
      self.form = self.querySelector('form');
      self.listId = self.form.dataset.list;
      self.apiKey = self.form.dataset.key;
      self.targetError = self.querySelector('.error');
      self.targetSuccess = self.querySelector('.success');
      self.processing = false;

      
      self.form.addEventListener("submit", function(e){
        event.preventDefault();
        console.log(self.querySelector('input[type="text"]').value);
        self.subscribe(self.apiKey, self.listId, self.querySelector('input[type="text"]').value);
      });
      
    }

    errorsuccessClear(){
      this.targetSuccess.innerHTML = this.targetError.innerHTML = '';
    }
  
    errorShow(text){
      this.targetError.innerHTML = text;
    }

    successShow(text){
      this.targetSuccess.innerHTML = text;
    }
    
    subscribe(apiKey, listId, email){
      let self = this;

      if(self.processing) {
        return;
      }

      self.processing = true;
      self.classList.add('loading');
      
      self.errorsuccessClear();

      let status;
      
      const options = {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-01-15',
        'content-type': 'application/vnd.api+json'
        },
        body: `{"data": {"type": "subscription","attributes": {"profile": {"data": {"type": "profile","attributes": {"email": "${email}","subscriptions": {"email": {"marketing": {"consent": "SUBSCRIBED"}}}}}}},"relationships": {"list": {"data": {"type": "list","id": "${listId}"}}}}}`
      };

      fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${apiKey}`, options)      
      .then(function(res){
        status = res.status;
        return res.headers.get("Content-Length") > 0 ? res.json() : null;
      })
      .then(function(data){

        // Success
        if(status === 202) {
          return self.successShow("✔️ Thanks for subscribing.");
        }
        
        // Client Error
        if(status >= 400 && status <= 499){
          if(data.errors && data.errors[0] && data.errors[0].detail) {
            return self.errorShow('❌ ' + data.errors[0].detail + '.');
          }
          return self.errorShow('❌ Something went wrong, please try again later.');
        }
        
        // Server Error
        if (status >= 500 && status <= 599){
          return self.errorShow('❌ Something went wrong, please try again later.');
        }
        
        return self.errorShow('❌ Something went wrong, please try again later.');
        
      })
      .then(function(){
        self.processing = false;
        self.classList.remove('loading');
      })
      .catch(error => function(){ 
        self.processing = false;
        self.classList.remove('loading');
        return self.errorShow('❌ Something went wrong, please try again later.');
      });
      
    }

}
customElements.define("serge-signupblock", SergeSignupBlock);  